
export default {
  name: 'InputDefault',
  props: {
    field: {
      type: Object,
      default: {
        name: '',
        label: '',
        type: 'text',
        value: '',
        // valid: /.*?/,
        touched: false,
        error: null,
        errors: {
          invalid: 'Please enter a valid value.'
        }
      }
    },
    type: String,
    loading: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: () => {}
    },
    passwordCriteria: {
      type: Array,
      default: () => {
        return [
          {
            name: 'length',
            valid: false,
            regex: '.{8,}'
          },
          {
            name: 'uppercase',
            valid: false,
            regex: '[A-Z]'
          },
          {
            name: 'lowercase',
            valid: false,
            regex: '[a-z]'
          },
          {
            name: 'number',
            valid: false,
            regex: '[0-9]'
          },
          {
            name: 'special',
            valid: false,
            regex: '[@$!%*?&]'
          },
        ]
      }
    },
  },
  methods: {
    // validate() {
    //   const valid = this.field.value && this.field.value.replace
    //     ? this.field.value.replace(/[- )(]/g,'').match(this.field.valid)
    //     : false
    //   this.field.error = valid ? null : this.field.errors.invalid
    //   return valid
    // },
    handleKeyup(e) {
      if(this.field.touched) {
        this.validate(this.field)
      }
      if(this.field.max && this.field.value.length > this.field.max) {
        this.field.value = this.field.value.slice(0, -1)
      }
      if (this.field.name === 'password' && this.passwordCriteria.length > 0) {
        this.passwordCriteria.forEach(criteria => {
          criteria.valid = new RegExp(criteria.regex).test(this.field.value)
        })
      }
    },
    handleBlur(e) {
      this.field.touched = true
      this.validate(this.field)
    }
  }
}
